import { render } from "./ChangePasswordForm.vue?vue&type=template&id=23f2fd2c&scoped=true&ts=true"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=ts"

import "./ChangePasswordForm.vue?vue&type=style&index=0&id=23f2fd2c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f2fd2c"]])

export default __exports__